__turbopack_context__.v({
  "cancelEditButton": "MKS0gW_cancelEditButton",
  "dropdown_btn": "MKS0gW_dropdown_btn",
  "editFinishButton": "MKS0gW_editFinishButton",
  "same_country_modal": "MKS0gW_same_country_modal",
  "text_content": "MKS0gW_text_content",
});
